import React, { useEffect, useState } from 'react';

import Select from 'react-select';
import api from '../../services/api';

/* Material UI */
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

//alerta
import ConfirmDialog from '../../components/Notification/ConfirmDialog';
import { toast } from 'react-toastify';

import InputMask from "react-input-mask";

import { Card } from '@material-ui/core';
import { CardContent } from '@mui/material';
import { FaEdit, FaEraser } from 'react-icons/fa';
import useWindowDimensions from '../../components/Sidebar/WindowDimensions';
import './styles.css';


const styleMultiSelect = {
  control: (base) => ({
    ...base,
    position: 'relative',
    minHeight: 56,
    width: '100%',
    marginTop: '0.5rem',
    minWidth: 35
  })
};

export default function UserRegister() {

  const { width } = useWindowDimensions();

  const classes = {
    textField: {
      width: '100%',
      backgroundColor: '#fff',
      marginTop: '0.5rem',
      borderRadius: '10px'
    },
    labelInput: {
      color: '#000',
      fontWeight: 'bold',
      paddingLeft: 2,
      fontSize: 14
    },
    select: {
      display: "block",
      height: (width > 1200 || width < 750 ? 'auto' : 39)
    },
    buttonClear: {
      backgroundColor: '#F5F5F5',
      color: '#174FB3',
      borderRadius: 20,
      height: '45px',
      textTransform: 'capitalize',
      fontWeight: 'bold',
      fontSize: 15,
      marginTop: '17px',
      minWidth: '220px'
    },
    buttonConfirm: {
      backgroundColor: '#1551B3',
      color: '#fff',
      borderRadius: 20,
      height: '45px',
      textTransform: 'capitalize',
      fontWeight: 'bold',
      fontSize: 15,
      marginTop: '17px',
      minWidth: '220px'
    },
    message: {
      padding: 10,
      backgroundColor: '#FFFBE8',
      color: 'rgba(0,0,0,0.8)',
      borderRadius: 7,
      width: '100%'
    }
  };

  // Permissão do usuário no sistema
  var userPermission;
  switch (localStorage.getItem('Permission')) {
    case 'Admin':
      userPermission = 'admin';
      break;
    case 'Controlador':
      userPermission = 'manager';
      break;
    case 'Executor':
      userPermission = 'executor';
      break;
    default:
      break;
  }

  var validationEmail = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

  // Estados
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [role, setRole] = useState([]);
  const [areasSelect, setAreasSelect] = useState([]);
  const [areas, setAreas] = useState([]);

  //alerta
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })

  /* Informações dos selects ************************************************ */
  // captura as áreas de atuação.
  // renomeia os campos do objeto para ser legível pelo componente multiselect.
  const areasAtuacao = areas.map(item => ({
    value: item.id,
    label: item.name
  }));

  // Tipos de usuários
  const typeUser = [
    { value: "1", label: "Executor" },
    { value: "2", label: "Controlador" },
    { value: "3", label: "Administrador" }
  ];
  /* ************************************************************************ */

  useEffect(() => {
    api.get('/admin/areas').then(response => {
      setAreas(response.data);
    });
  }, []);

  function clearForm() {
    setName('');
    setPassword('');
    setConfirmPassword('');
    setEmail('');
    setTelefone('');
    setAreasSelect([]);
    setRole([]);
  }

  //chama o alerta para cadastrar
  function confirms() {

    let data = {};
    let user = '';

    switch (role) {
      case "Controlador":
        data = {
          name,
          email,
          password,
          telefone,
          role,
          manager: areasSelect.map(item => ({
            id: item.value,
            name: item.label
          })
          )
        }
        break;

      case "Executor":
        data = {
          name,
          email,
          password,
          telefone,
          role,
          executor: areasSelect.map(item => ({
            id: item.value,
            name: item.label
          })
          )
        }
        break;

      case "Admin":
        data = {
          name,
          email,
          password,
          telefone,
          role
        };
        break;

      default:
        break;
    }
    if (role === 'Admin') {
      user = 'Administrador';
    } else {
      user = role;
    }
    setConfirmDialog({
      isOpen: true,
      title: `Você tem certeza que deseja cadastar ${name} como ${user}?`,
      subTitle: '',
      onConfirm: () => { handleRegistrer(data) }
    })
  }

  async function handleRegistrer(data) {

    /* * O objeto data será enviado pela api para o endpoint /users.
       * Destaca-se a necessidade de renomear o objeto areasSelect, para que o mesmo
         tenha os mesmo campos permitidos no campo manager ou executor da api
         (value => id | label => name). *

    /* Muda o objeto caso seja selecionado que o usuário é Controlador ou Executor */



    if (password !== confirmPassword) {
      toast.warning('As senhas não coincidem.');
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });
    } else if (!validationEmail.test(email)) {
      toast.warning('Digite um email válido.');
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });
    } else if (password.length < 8 || confirmPassword < 8) {
      toast.warning('A senha deve conter mais que 8 caracteres.');
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });
    } else {
      try {
        await api.post(`${userPermission}/users`, data);

        setConfirmDialog({
          isOpen: false,
          title: ``,
          subTitle: '',
        })

        // janela de notificação de sucesso
        toast.success('Usuário cadastrado com sucesso.');

        // window.location.reload();
        clearForm()

      } catch (err) {
        let message = 'Ocorreu um erro ao registrar o usuário.'

        if (err.message === 'Network Error') {
          message = 'Erro de conexão com o servidor. Verifique se o servidor está disponível.';
        } else if (err.response?.status === 422) {
          message = err.response.data?.error?.message || message;
        }

        toast.error(message);

        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        });
      }
    }
  };

  return (
    <>
      <Card style={{ overflow: 'inherit', backgroundColor: '#F5F5F5', boxShadow: 'none' }}>
        <CardContent>
          <Typography variant="h5" align="center" style={{
            margin: 8,
            color: '#103168',
            fontWeight: 600,
            marginBottom: 30,
          }}>
            Cadastro de usuários
          </Typography>

          <div style={classes.message}>
            Preencha o formulário abaixo para cadastrar um usuário. Atente-se em cadastrar o(s) tipo(s) vinculadas a esse usuário.
          </div>

          <div id='form-user-register' style={{ scrollMarginTop: 50 }}>
            <Grid container spacing={2} justifyContent='center' style={{ marginTop: 20 }}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography variant="span" style={classes.labelInput}>
                  Nome completo: *
                </Typography>

                <TextField placeholder="Digite o nome do usuário"
                  sx={classes.textField}
                  variant="outlined"
                  required
                  fullWidth
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography variant="span" style={classes.labelInput}>
                  E-mail: *
                </Typography>

                <TextField placeholder="Digite o email do Usuário"
                  style={classes.textField}
                  variant="outlined"
                  fullWidth
                  required
                  error={email !== "" ? (!validationEmail.test(email)) : false}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Typography variant="span" style={classes.labelInput}>
                  Telefone:
                </Typography>

                <InputMask
                  mask="(99) 9 9999-9999"
                  maskChar=" "
                  type="tel"
                  value={telefone}
                  onChange={e => setTelefone(e.target.value)}
                >
                  {() => <TextField placeholder="Digite o telefone de usuário"
                    style={classes.textField}
                    fullWidth
                    variant="outlined"
                  />}
                </InputMask>
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Typography variant="span" style={classes.labelInput}>
                  Senha: *
                </Typography>

                <TextField placeholder="Digite a senha do usuário"
                  style={classes.textField}
                  variant="outlined"
                  required
                  fullWidth
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <Typography variant="span" style={classes.labelInput}>
                  Confirmação de Senha: *
                </Typography>

                <TextField placeholder="Confirme a senha do usuário"
                  style={classes.textField}
                  variant="outlined"
                  required
                  fullWidth
                  error={!!password && !!confirmPassword && password !== confirmPassword}
                  /*helperText={password !== confirmPassword ? "Senhas não coincidem" : ""}*/
                  type="password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={areasSelect.length > 5 || role === 'Admin' || !role ? 12 : 6}
                lg={areasSelect.length > 5 || role === 'Admin' || !role ? 12 : 6}
                xl={areasSelect.length > 5 || role === 'Admin' || !role ? 12 : 6}
              >
                <Typography variant="span" style={{ ...classes.labelInput, ...classes.select }}>
                  Selecione o tipo de usuário:
                </Typography>

                <Select options={typeUser}
                  onChange={e => e.label === 'Administrador' ? setRole('Admin') : setRole(e.label)}
                  styles={styleMultiSelect}
                  placeholder=""
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={areasSelect.length > 5 ? 12 : 6}
                lg={areasSelect.length > 5 ? 12 : 6}
                xl={areasSelect.length > 5 ? 12 : 6}
              >
                {role !== 'Admin' ?
                  [<Typography key="label" variant="span" style={{ ...classes.labelInput, ...classes.select }}>
                    Selecione um ou mais tipos vinculados ao usuário:
                  </Typography>,
                  <Select isMulti
                    key="select"
                    options={areasAtuacao}
                    styles={styleMultiSelect}
                    value={areasSelect}
                    onChange={e => setAreasSelect(e)}
                    placeholder=""
                  />] : false}
              </Grid>
            </Grid>

          </div>
        </CardContent>
      </Card>

      <Grid container spacing={2} item justifyContent='center' >
        <Grid item id='buttons-user-register-clear'>
          <Button
            variant="outlined"
            startIcon={<FaEraser style={{ 'color': '#174FB3' }} />}
            type='button'
            onClick={() => clearForm()}
            style={classes.buttonClear}
          >
            Limpar
          </Button>
        </Grid>

        <Grid item id='buttons-user-register-confirm'>
          <Button
            variant="outlined"
            startIcon={<FaEdit style={{ 'color': '#fff' }} />}
            onClick={() => confirms()}
            style={classes.buttonConfirm}
          >
            Cadastrar Usuário
          </Button>
        </Grid>
      </Grid>

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>


  );
}
